import { render } from "./topicManager.vue?vue&type=template&id=2c5a45b2&scoped=true"
import script from "./topicManager.vue?vue&type=script&lang=js"
export * from "./topicManager.vue?vue&type=script&lang=js"

import "./topicManager.vue?vue&type=style&index=0&id=2c5a45b2&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5a45b2"]])

export default __exports__